import React from 'react'
import { BillingoPartner } from '../models/BillingoPartner'
import { Paper, IconButton } from '@mui/material';
import { primary } from '../styles/colors';
import PersonIcon from '@mui/icons-material/Person';
import BadgeIcon from '@mui/icons-material/Badge';
import PhoneIcon from '@mui/icons-material/Phone';
import ApartmentIcon from '@mui/icons-material/Apartment';
import EditIcon from '@mui/icons-material/Edit';
import { useTranslation } from 'react-i18next';
import EmailIcon from '@mui/icons-material/Email';

type Props = {
    billingoPartner: BillingoPartner;
    onEditClick: () => void;
}

const BillingoPartnerPaper = ({ billingoPartner, onEditClick }: Props) => {
    const { t } = useTranslation();
    return (
        <Paper>
            <div className="px-2 py-2 flex flex-row" >
                <div className="grow">
                    <div>
                        <PersonIcon style={{ color: primary.dark, marginBottom: "4px" }} /> {billingoPartner.name}
                    </div>
                    {billingoPartner.taxcode && (
                        <div>
                            <BadgeIcon style={{ color: primary.dark, marginBottom: "4px" }} /> {billingoPartner.taxcode}
                        </div>)}
                    <div>
                    </div>
                    <div>
                        <ApartmentIcon style={{ color: primary.dark, marginBottom: "4px" }} /> {t("common.hungary")}, {billingoPartner.address.post_code} {billingoPartner.address.city}, {billingoPartner.address.address}
                    </div>
                    {billingoPartner.phone && (
                        <div>
                            <PhoneIcon style={{ color: primary.dark, marginBottom: "4px" }} /> {billingoPartner.phone}
                        </div>)}
                    {billingoPartner.emails.length > 0 && (
                        <div>
                            <EmailIcon style={{ color: primary.dark, marginBottom: "4px" }} /> {billingoPartner.emails.join(", ")}
                        </div>
                    )}
                </div>
                <div>
                    <IconButton
                        onClick={onEditClick}
                    >
                        <EditIcon style={{ color: primary.dark }} />
                    </IconButton>
                </div>
            </div>
        </Paper>
    )
}

export default BillingoPartnerPaper